module.exports = __webpack_public_path__ + "img/HIW-COVER.6cc85cef.png";